import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	heading: {
		id: 'subpage.stress.hero.heading',
		defaultMessage: 'Anxiety and stress relief whenever you need it',
		description: 'Heading for the stress category page hero',
	},
	body: {
		id: 'subpage.stress.hero.body',
		defaultMessage:
			'Learn how to calm anxiety and find the tools for in-the-moment stress relief. Our clinical experts and meditation teachers are here with a wide range of stress relief programs, meditations for anxiety, and guided content to help you soothe anxiety and feel better.',
		description: 'Body text for the stress category page hero',
	},
	cta: {
		id: 'subpage.stress.hero.cta',
		defaultMessage: 'Relieve your stress for free',
		description: 'Button text for the stress category page hero',
	},
});
